export default {
    requiredField: 'Pole {{field}} je povinné.',
    shouldBeNumber: 'Pole {{field}} by mělo být číslo.',
    shouldBeString: 'Pole {{field}} by mělo být řetězec.',
    stringShouldHaveMinLength: "U pole {{field}} použijte minimálně {{minLength}} $t(common:char, {'count': {{minLength}}}).",
    stringShouldHaveMaxLength: "U pole {{field}} použijte maximálně {{maxLength}} $t(common:char, {'count': {{maxLength}}}).",
    stringShouldHaveLength: "U pole {{field}} použijte {{length}} $t(common:char, {'count': {{length}}}).",
    numberMinValue: 'U pole {{field}} použijte číslo větší nebo rovno {{min}}.',
    numberMaxValue: 'U pole {{field}} použijte číslo rovné nebo menší než {{max}}.',
    emailShouldContainAt: "Email by měl obsahovat zavináč - '@'.",
    emailShouldContainDomain: "Email by měl obsahovat doménu. Například '.cz' nebo '.com'.",
    emailShouldHaveValidFormat: "Email by měl být ve správném formátu. Například 'vase@jmeno.cz'",
    emailContainsDiacritics: 'Email nesmí obsahovat diakritiku.',
    emailDomainContainsValidChars: 'E-mail nesmí obsahovat diakritiku a nepovolené znaky.',
    incorrectDateInserted: 'Den v měsíci u pole {{field}} není udán správně.',
    incorrectMonthInserted: 'Měsíc v roce u pole {{field}} není udán správně.',
    incorrectYearInserted: 'Rok v poli {{field}} není udán správně.',
    incorrectDateFormat: 'Formát data v poli {{field}} není správný. Vložte datum ve formátu {{format}}',
    dateNotBefore: 'Datum v poli {{field}} musí předcházet datu {{before, DD.MM.YYYY}}.',
    dateNotAfter: 'Datum v poli {{field}} musí následovat za datem {{after, DD.MM.YYYY}}.',
    birthNumberNotCorrect: 'Vložené rodné číslo není platné.',
    birthNumberContainsSlash: 'Prosím, odstraňte vložené lomítko.',
    icNotCorrect: 'Vložené IČ není platné.',
    shouldHaveNoWhitespaces: '{{field}} nesmí obsahovat mezery.',
    shouldHaveNoPunctation: '{{field}} nesmí obsahovat interpunkční znaky jako např. tečky, čárky, nebo závorky.',
    shouldHaveNoPunctationStrict: 'Pole {{field}} obsahuje nepovolené znaky.',
    onlyAllowedChars: 'Pole {{field}} obsahuje nepovolené znaky.',
    shouldHaveOnlyDigits: 'Pole {{field}} může obsahovat pouze číslice.',
    isAlphanumerical: 'Pole {{field}} může obsahovat pouze písmena a číslice.',
    isAlphanumericalUpper: 'Pole {{field}} může obsahovat pouze velká písmena a číslice.',
    isAlphanumericalLower: 'Pole {{field}} může obsahovat pouze malá písmena a číslice.',
    companyNameIncorrect: 'Pole {{field}} obsahuje neplatné znaky.',
    phoneIncorrect: 'Telefonní číslo není správně. Zadejte buď 12 znaků s + na začátku, nebo 9 číslic.',
    wrongExtension: 'Nepodporovaná přípona souboru',
    wrongSize: 'Nepodporovaná velikost souboru',
    wrongSizeDropzone: '<strong>{{fieldValueIndexed.name}}</strong> je příliš velký ({{sizeMb, number(style: unit; unit: megabyte)}})',
    uploadTotalMaxSize: 'Celková velikost souborů překročila limit {{maxSizeMb, number(style: unit; unit: megabyte)}} (celkem: {{sizeMb, number(style: unit; unit: megabyte)}})',
    wrongExtensionDropzone: '<strong>{{fieldValueIndexed.name}}</strong> má nepodporovanou příponu souboru',
    uploadHasError: 'Pole {{field}} obsahuje nevalidní soubory.',
    incorrectVinFormat: 'Nevalidní VIN formát',
    incorrectVatFormat: 'Nevalidní DIČ formát',
    zipNotCorrect: 'Nevalidní formát PSČ',
    uploadMaxNumOfFiles: "Můžete nahrát maximálně {{numOfFiles}} $t(common:file, {'count': {{numOfFiles}}})."
};
